import Link from '@/_application/core/components/ui/link';
import {isMobileDevice} from '@/_application/core/hooks/useIsMobileDevice';
import {Product, getProductUrl} from '@/_application/modules/products/model/product';
import cn from 'classnames';

const classess = {
    basic: 'line-clamp-2 cursor-pointer text-KPZ_text_1st normal-case hover:text-primary transition-colors',
    smallSizeAndMobile: 'text-sm! h-10! text-KPZ_Gray-31!',
    bigSizeAndMobile: 'text-base font-bold md:w-[95%] w-[80%]',
    smallSizeAndDesktop: 'text-sm h-10',
    bigSizeAndDesktop: 'text-xl font-bold w-[85%] h-14',
};

export const ProductName = ({
    product,
    size,
    className,
}: {
    product: Product;
    size?: 'small' | 'big';
    className?: string;
}) => {
    const isMobile = isMobileDevice();
    const {name} = product ?? {};

    if (!name) {
        return <></>;
    }

    const classesName = cn(
        classess.basic,
        {
            [classess.smallSizeAndMobile]: size === 'small' && isMobile,
            [classess.bigSizeAndMobile]: size === 'big' && isMobile,
            [classess.smallSizeAndDesktop]: size === 'small' && !isMobile,
            [classess.bigSizeAndDesktop]: size === 'big' && !isMobile,
        },
        className,
    );

    const {id, sku} = product;

    const webviewData = {
        screen: 'pdp',
        params: {
            sku: sku,
            id: id,
        },
    };
    const webViewNavigation = !!(typeof window !== 'undefined' && window.ReactNativeWebView);
    return (
        <Link
            href={getProductUrl(product, false)}
            webViewNavigation={webViewNavigation}
            webViewData={JSON.stringify(webviewData)}>
            <h3 title={name} className={classesName}>
                {name}
            </h3>
        </Link>
    );
};
